/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Notifications object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Notifications = {
    init: function () {
        $("#btn-notifications").click(function () {
            if (Notifications.opened) Notifications.close();
            else Notifications.open();
        });

        var count = 0;
        Status.add("notifications", function (data) {
            if (data.count && data.count.notifications != count) {
                if (data.count.notifications == 0)
                    $("#btn-notifications > .count").hide();
                else
                    $("#btn-notifications > .count")
                        .html(data.count.notifications)
                        .css("display", "block");

                History.notifications +=
                    -count + parseInt(data.count.notifications);
                History.reloadNotifications();

                count = data.count.notifications;
            }
        });
    },
    open: function () {
        Notifications.opened = true;
        // DOM
        $("body").append('<div id="notifications-background"></div>');
        $("#header-account > .btn-group").append(
            '<div id="notifications-box"><div class="arrow"><div></div></div><div class="content"><div class="body" style="padding: 25px 0;text-align: center;"><img src="//cdn.habtium.com/management/ajax-loader.gif" style=""></div></div></div>'
        );

        // Parameters
        var locked = false;

        // Load notifications
        Api.get("/notifications", {}, function (data) {
            $("#notifications-box").click(function (e) {
                e.stopPropagation();
                return false;
            });
            $(document).click(Notifications.close);

            if (data.error) {
                var error =
                    data.error.identifier == "empty_set"
                        ? "notifications_empty_set"
                        : "notifications_error";

                Language.get(error).then(function (strings) {
                    $("#notifications-box > .content").html(
                        '<div class="body" style="padding: 25px 0;text-align: center;">' +
                            strings[0] +
                            "</div>"
                    );
                });
            } else {
                // Load accounts
                Accounts.getByAccountIfNot(data, function () {
                    $("#notifications-box > .content").html(
                        '<div class="body"></div>'
                    );
                    Notifications.put(data, "append");

                    // Load more
                    $("#notifications-box > .content > .body").scroll(
                        function () {
                            var self = $(this);
                            if (
                                !locked &&
                                self.scrollTop() + self.innerHeight() >=
                                    $(this)[0].scrollHeight - 10
                            ) {
                                locked = true;
                                self.append(
                                    '<div class="loading" style="text-align: center;"><img src="//cdn.habtium.com/management/ajax-loader.gif" style=""></div>'
                                );
                                Api.get(
                                    "/notifications",
                                    {
                                        first: $(".notification:last").data(
                                            "id"
                                        ),
                                    },
                                    function (data) {
                                        if (data.error)
                                            self.children(".loading").remove();
                                        else
                                            Accounts.getByAccountIfNot(
                                                data,
                                                function () {
                                                    Notifications.put(
                                                        data,
                                                        "append"
                                                    );
                                                    locked = false;
                                                    self.children(
                                                        ".loading"
                                                    ).remove();
                                                }
                                            );
                                    }
                                );
                            }
                        }
                    );
                });
            }
        });
    },
    put: function (notifications, pos) {
        var list = "";
        for (var i in notifications) {
            var account = accounts[notifications[i].account.id];
            var text;
            var link;
            switch (notifications[i].type) {
                case 1:
                    // NEW FOLLOWER
                    text = "%USER% ha comenzado a seguirte.";
                    link = "/" + account.username;
                    break;
                case 2:
                    // NEW MENTION
                    text = "%USER% te ha mencionado en %PLACE%.";
                    switch (notifications[i].place) {
                        case 1:
                            // FORUM
                            text = text.replace("%PLACE%", "un tema del foro");
                            link = notifications[i].params["url"];
                            break;
                        case 2:
                            // NEW
                            text = text.replace("%PLACE%", "una noticia");
                            link = notifications[i].params["url"];
                            break;
                        case 3:
                            // EVENT
                            text = text.replace("%PLACE%", "un evento");
                            link = notifications[i].params["url"];
                            break;
                        case 4:
                            // ARTICLE
                            text = text.replace("%PLACE%", "un artículo");
                            link = notifications[i].params["url"];
                            break;
                        case 5:
                            // BLOG
                            text = text.replace("%PLACE%", "un blog");
                            link = notifications[i].params["url"];
                            break;
                        case 6:
                            // PROFILE
                            text = text.replace("%PLACE%", "un perfil");
                            link = notifications[i].params["url"];
                            break;
                        case 7:
                            // GAME
                            text = text.replace("%PLACE%", "un juego");
                            link = notifications[i].params["url"];
                            break;
                        case 8:
                            // STORY
                            text = text.replace("%PLACE%", "una historia");
                            link = notifications[i].params["url"];
                            break;
                    }
                    break;
                case 3:
                    // NEW LIKE
                    if (notifications[i].total == 1)
                        text = "A %USER% le ha gustado %ITEM%.";
                    else if (notifications[i].total == 2)
                        text =
                            "A %USER% y a otra persona les ha gustado %ITEM%.";
                    else
                        text =
                            "A %USER% y a otras %COUNT% personas les ha gustado %ITEM%.".replace(
                                "%COUNT%",
                                notifications[i].total - 1
                            );
                    switch (notifications[i].place) {
                        case 1:
                            // FORUM
                            text = text.replace(
                                "%ITEM%",
                                "tu mensaje en el foro"
                            );
                            link = notifications[i].params["url"];
                            break;
                    }
                    break;
                case 4:
                    // NEW AFRO
                    text = "Has recibido %DAYS% días afro.".replace(
                        "%DAYS%",
                        notifications[i].params.time
                    );
                    link = "/store";
                    break;
                case 5:
                    // NEW COINS
                    text = "Se han sumado %AMOUNT% tiums en tu cuenta.".replace(
                        "%AMOUNT%",
                        notifications[i].params.coins
                    );
                    link = "/store";
                    break;
                case 6:
                    // NEW ACHIEVEMENT
                    text = "Has recibido un nuevo logro.";
                    link = $("#go-profile").attr("href") + "/achievements";
                    break;
                case 7:
                    // NEW INCIDENCE
                    text = "Se ha añadido una nueva incidencia.";
                    link = "/penalties/incidences";
                    break;
                case 8:
                    // SUPPORT REQUEST
                    text = "%USER% ha respondido tu solicitud de soporte.";
                    link = "/support";
                    break;
                case 9:
                    // NEW COMMENT ON PROFILE
                    text = "%USER% ha dejado un comentario en tu perfil.";
                    link =
                        $("#go-profile").attr("href") +
                        "#" +
                        notifications[i].params.comment;
                    break;
                case 10:
                    // HEADER DENIED
                    text = "Tu cabecera ha sido denegada.";
                    link = "/account/profile";
                    break;
                case 11:
                    // PROFILE IMAGE DENIED
                    text = "Tu imagen de perfil ha sido denegada.";
                    link = "/account/profile";
                    break;
                case 12:
                    // BIO REFUSED
                    text = "Tu biografía ha sido rechazada.";
                    link = "/account/profile";
                    break;
                case 13:
                    // NAME REFUSED
                    text = "Tu nombre ha sido rechazado.";
                    link = "/account";
                    break;
                case 14:
                    // FOLLOWING (Only forum temporaly)
                    text = '%USER% ha respondido en el tema "%TOPIC%"'.replace(
                        "%TOPIC%",
                        notifications[i].params["title"]
                    );
                    link =
                        "/forum/topic/" + notifications[i].id_item + "/new#new";
                    break;
                case 15:
                    // WEBSITE DENIED
                    text = "Tu sitio web ha sido rechazado.";
                    link = "/account";
                    break;
                case 16:
                    // YOUTUBE DENIED
                    text = "Tu video de perfil ha sido rechazado.";
                    link = "/account/profile";
                    break;
                case 17:
                    // HAL: Request add response
                    text =
                        "Se ha añadido/editado la respuesta de tu petición #%NUMBER%.".replace(
                            "%NUMBER%",
                            notifications[i].params["id"]
                        );
                    link = "/";
                    break;
                case 18:
                    // HAL: Request update status
                    text =
                        "Se ha editado el estado de tu petición #%NUMBER%.".replace(
                            "%NUMBER%",
                            notifications[i].params["id"]
                        );
                    link = "/";
                    break;
                case 19:
                    // NEW POINT
                    text =
                        "Se han sumado %AMOUNT% puntos en tu cuenta.".replace(
                            "%AMOUNT%",
                            notifications[i].params.score
                        );
                    link = "/";
                    break;
                case 20:
                    // REJECT TWITTER
                    text = "Tu cuenta de twitter ha sido rechazada.";
                    link = "/account/profile";
                    break;
                case 21:
                    // NEW WARNING.
                    text = "Se ha añadido una nueva alerta a tu cuenta.";
                    link =
                        "/penalties/warnings/show/" +
                        notifications[i].params["warning_id"];
                    break;
                case 22:
                    // REQUEST DELETE ADDED.
                    text =
                        "Tu solicitud para eliminar tu cuenta se ha registrado con éxito. Este proceso puede tardar entre 24 a 48 horas hábiles.";
                    link = "/account/security";
                    break;
                case 24:
                    text = "Se ha sumado un nuevo efecto a tu cuenta.";
                    link = "/account/profile";
                    break;
                case 25:
                    text =
                        "Se han sumado %AMOUNT% copos de nieve en tu cuenta.".replace(
                            "%AMOUNT%",
                            notifications[i].params.snowflakes
                        );
                    link = "/christmas/store";
                    break;
                case 26:
                    text =
                        "Se ha sumado un nuevo furni en tu cuenta. Contacta con Habtium en Habbo.es para reclamarlo.";
                    link = "/store";
                    break;
                case 27:
                    text = "Se ha sumado  un premio a tu cuenta.";
                    link = "/christmas";
                    break;
                case 28:
                    text =
                        "Se ha rechazado una historia que enviaste a revisión.";
                    link = "/stories";
                    break;
                case 29:
                    text = "Se ha sumado un nuevo ícono de nick a tu cuenta.";
                    link = "/account/profile";
                    break;
                case 30:
                    text = "Se ha sumado un nuevo sticker a tu cuenta.";
                    link = "/stickers/my";
                    break;
                case 31:
                    text = "Tu balance de habbo créditos ha sido actualizado.";
                    link = "/store/redeem";
                    break;
                case 32:
                    text =
                        "Se ha sumado un pase para la placa del mes a tu cuenta.";
                    link = "/events";
                    break;
                case 33:
                    // NEW AFRO HOURS
                    text = "Has recibido %DAYS% horas afro.".replace(
                        "%DAYS%",
                        notifications[i].params.time
                    );
                    link = "/store";
                    break;
                case 34:
                    text =
                        "Has recibido un nuevo regalo. Descubre todo los detalles en tu buzón.";
                    link = "/store/mailbox";
                    break;
                case 35:
                    text =
                        "Has recibido una solicitud de candado de amistad web.";
                    link = "//neo.habtium.es";
                    break;
                case 36:
                    text =
                        "Ha aceptado tu solicitud de candado de amistad web.";
                    link = "/";
                    break;
                case 37:
                    text =
                        "Ha rechazado tu solicitud de candado de amistad web.";
                    link = "/";
                    break;
                case 38:
                    text = "Un trofeo web ha sido sumado a tu cuenta.";
                    link = $("#go-profile").attr("href") + "/trophies";
                    break;
                case 39:
                    text =
                        "Has recibido un pase para una placa en tu cuenta. Contacta por soporte para reclamar el premio.";
                    link = "/";
                    break;
                case 23:
                    // NEW TOKEN ADDED.
                    text =
                        "Se han sumado %AMOUNT% %CURRENCY_NAME% en tu cuenta."
                            .replace("%AMOUNT%", notifications[i].params.amount)
                            .replace(
                                "%CURRENCY_NAME%",
                                notifications[i].params.currency_name
                            );
                    link = "//app.habtium.es/calendar/halloween-2023";
                    break;
                case 40:
                    // NEW COINS
                    text =
                        "Se han restado %AMOUNT% tiums en tu cuenta.".replace(
                            "%AMOUNT%",
                            notifications[i].params.coins
                        );
                    link = "/store";
                    break;
            }
            text = text.replace("%USER%", "<b>" + account.name + "</b>");
            list +=
                '<a href="' +
                link +
                '"><div data-new data-id="' +
                notifications[i].id +
                '" class="notification' +
                (notifications[i].seen == 0 ? " unseen" : "") +
                '"><img style="float:left;margin-right: 8px;border-radius: 100%;width: 40px;height: 40px;background-size: cover;background-repeat: no-repeat;background-position: center center!important;" src="' +
                account.avatar +
                '"><div style="vertical-align: middle;display: table-cell;width: 100%;font-size: 13px;">' +
                text +
                "</div></div></a>";
        }
        $("#notifications-box > .content > .body")[pos](list);
        $(".notification[data-new]")
            .click(function () {
                window.location = $(this).parent().attr("href");
            })
            .removeAttr("data-new");
    },
    close: function () {
        Notifications.opened = false;
        $("#notifications-box").remove();
        $("#notifications-background").remove();
        $(document).unbind("click", Notifications.close);
    },
};
